module.exports = __webpack_public_path__ + "static/media/atik.55fbef5d.jpeg";